<template>
  <div class="user-class">
    <el-form
      :inline="true"
      :model="dataForm"
      @keyup.enter.native="getDataList()"
    >
      <el-form-item label="">
        <el-input
          v-model="dataForm.groupName"
          placeholder="班级名称"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-dict-select
          placeholder="班主任"
          v-model="dataForm.userId"
          type="teacherSelects"
          :props="{ label: 'realName', value: 'userId' }"
        ></el-dict-select>
      </el-form-item>
      <el-form-item label="" prop="groupStage">
        <el-dict-select
                placeholder="学段"
                v-model="dataForm.groupStage"
                type="openDict"
                :props="{ label: 'value', value: 'code' }"
                :params="groupStageParams"
        ></el-dict-select>
      </el-form-item>
      <el-form-item label="">
        <el-dict-select
                v-if="manageOrgIdFlag()"
                placeholder="选择机构"
                v-model="dataForm.orgId"
                type="orgList"
        ></el-dict-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="rgetDataList()">查询</el-button>

      </el-form-item>
    </el-form>
    <el-row style="margin-bottom: 1rem;">
      <el-col>
        <el-button v-if="isAuth('course:studentGroup:save')" type="primary" @click="addOrUpdateHandle()">新增</el-button>
        <el-button type="info" @click="excel" v-if="isAuth('sys:studentGroup:export')" >导出<i class="el-icon-download"></i></el-button>
      </el-col>
    </el-row>
    <el-table
      :data="dataList"
      border
      v-loading="dataListLoading"
      style="width: 100%"
    >
      <el-table-column
              type="index"
              header-align="center"
              align="center"
              label="序号"
              :index="indexMethod"
              width="50" >
      </el-table-column>
      <el-table-column
        prop="groupName"
        header-align="center"
        align="center"
        label="班级"
      >
      </el-table-column>
      <el-table-column
        prop="userName"
        header-align="center"
        align="center"
        label="班主任"
      >
      </el-table-column>
      <el-table-column
          v-if="manageOrgIdFlag()"
          prop="orgName"
          header-align="center"
          align="center"
          label="所属机构"
      >
      </el-table-column>
      <el-table-column
        prop="studentNum"
        header-align="center"
        align="center"
        label="学生数量"
      >
      </el-table-column>
      <el-table-column
              prop="groupStageName"
              header-align="center"
              align="center"
              label="学段"
      >
      </el-table-column>
      <el-table-column
        prop="startTime"
        header-align="center"
        align="center"
        label="上课时间"
      >
      </el-table-column>
      <el-table-column
        prop="endTime"
        header-align="center"
        align="center"
        label="下课时间"
      >
      </el-table-column>

      <el-table-column
              prop="createTime"
              header-align="center"
              align="center"
              label="创建时间"
      >
      </el-table-column>
      <el-table-column
              prop="updateTime"
              header-align="center"
              align="center"
              label="修改时间"
      >
      </el-table-column>
      <el-table-column
              prop="opsName"
              header-align="center"
              align="center"
              label="修改人"
      >
      </el-table-column>
      <el-table-column

        header-align="center"
        align="center"
        width="150"
        label="操作"
      >
        <template slot-scope="{ row }">
          <el-button
            v-if="isAuth('course:studentClass:update')"
            type="text"
            size="small"
            @click="addOrUpdateHandle(row.id)"
          >
            修改
          </el-button>
          <el-button
            v-if="isAuth('course:studentClass:delete')"
            type="text"
            size="small"
            @click="deleteHandle(row)" style="color:#F56E6E"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
      :current-page="pageIndex"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      :total="totalPage"
      layout="total, sizes, prev, pager, next, jumper"
    >
    </el-pagination>
    <!-- 弹窗, 新增 / 修改 -->
    <add-or-update
      v-if="addOrUpdateVisible"
      ref="addOrUpdate"
      @refreshDataList="getDataList"
    ></add-or-update>
  </div>
</template>

<script>
import AddOrUpdate from "./class-add-or-update";
import {getLoginToken} from "../../../utils";

export default {
  data() {
    return {
      dataForm: {
        realName: "",
        userName: "",
        orgId: "",
        groupStage: "",
      },
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      addOrUpdateVisible: false,
    };
  },
  computed: {
    groupStageParams() {
      return { type: "StudentStage" };
    },
  },
  components: {
    AddOrUpdate,
  },
  created() {
    this.getDataList();
    this.doSearch();
  },
  methods: {
    indexMethod(index) {
      return (this.pageIndex-1) * this.pageSize + index + 1;
    },
    // 获取数据列表
    getDataList() {
      this.dataListLoading = true;
      this.$http({
        url: this.$http.adornUrl("course/studentGroup/list"),
        method: "get",
        params: this.$http.adornParams({
          page: this.pageIndex,
          limit: this.pageSize,
          ...this.dataForm,
        }),
      }).then(({ data }) => {
        // console.log(data, '班级')
        if (data && data.code === 0) {
          this.dataList = data.page.list;
          this.totalPage = data.page.totalCount;
        } else {
          this.dataList = [];
          this.totalPage = 0;
        }
        this.dataListLoading = false;
      });
    },
    excel(){
      let url = this.$http.adornUrl("course/studentGroup/excel")
      let param = "?token=" + getLoginToken()
      param += "&realName=" + this.dataForm.realName
      param += "&username=" + this.dataForm.username
      param += "&orgId=" + this.dataForm.orgId
      param += "&groupStage=" + this.dataForm.groupStage
      url =  url + param;
      window.location.href = url;
    },
    doSearch() {
      let that = this;
      document.onkeypress = function (e) {
        let keycode = document.all ? event.keyCode : e.which;
        if (keycode == 13) {
          that.rgetDataList();
        }
      }
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataList();
    },
    // 新增 / 修改
    addOrUpdateHandle(id) {
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id);
      });
    },
    // 删除
    deleteHandle(row) {
      const { id, groupName } = row;
      this.$confirm(`确定删除${groupName}?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$http({
          url: this.$http.adornUrl("course/studentGroup/delete"),
          method: "delete",
          data: id,
        }).then(({ data }) => {
          if (data && data.code === 0) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.getDataList();
          } else {
            this.$message.error(data.msg);
          }
        });
      });
    },
  },
};
</script>
